<div class="w-100 mt-0 tool-container">
  <h4>Import Products</h4>
  <mat-form-field class="me-3">
    <mat-label>Table Name</mat-label>
    <mat-select [(ngModel)]="uploadLifeProducts.table">
      @for (opt of lifeProductTables; track opt) {
        <mat-option [value]="opt">
          {{ opt.display }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <span class="file-container">
    <input
      type="file"
      class="file-input"
      (change)="onFileSelected($event)"
      #fileUpload
    />

    <span class="file-upload">
      {{ uploadFileName || 'No file selected yet' }}

      <button
        mat-mini-fab
        color="primary"
        class="upload-btn"
        (click)="fileUpload.click()"
      >
        <mat-icon>attach_file</mat-icon>
      </button>
    </span>
  </span>
  <button
    mat-raised-button
    color="primary"
    class="mx-auto"
    (click)="uploadLifeProduct()"
    [disabled]="!uploadLifeProducts.table || !uploadFile"
  >
    Import
  </button>
  @if (uploadLifeProducts.status) {
    <h4 class="col-12 {{ uploadLifeProducts.statusClass }}">
      {{ uploadLifeProducts.status }}
    </h4>
  }
</div>
